import { render } from "./SimpleDropdown.vue?vue&type=template&id=644cd80c"
import script from "./SimpleDropdown.vue?vue&type=script&lang=js"
export * from "./SimpleDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__